import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import LeftSidePopupLayout from "../../../../component/popup/modal-layout";
import XCloseIcon from "../../../../component/icons/x-close";
// import Style from "./style.module.css";
import { GlobalContext } from "../../../../context/Context";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import Tooltip from "../../../../component/ui/tooltip";
import { Loader2, Trash2 } from "lucide-react";
import Select from "react-select";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
  FormLineBreak,
} from "../../../../component/form/form-layout";

const stripHtml = (html) => (html || "").replace(/<[^>]*>?/gm, "");

const AddUpdateSubProduct = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  Style,
  subProductData,
}) => {
  const { state } = useContext(GlobalContext);
  const apiCall = useApiCall();

  const [mainProducts, setMainProducts] = useState([]);
  const [loadindProducts, setLoadingProducts] = useState(false);
  const [status, setStatus] = useState(1);

  const statusOptions = [
    {
      value: 1,
      label: "Acitve",
    },
    {
      value: 0,
      label: "InActive",
    },
  ];

  const getMainProducts = async () => {
    setLoadingProducts(true);
    try {
      let res = await apiCall({
        method: "get",
        url: "products/products-list?is_paginate=0",
      });
      setMainProducts(res?.data || []);
    } catch (error) {
      console.warn("Error loading main products:", error);
    } finally {
      setLoadingProducts(false);
    }
  };

  useEffect(() => {
    getMainProducts();

    if (subProductData?.id) {
      formik.setFieldValue("products", subProductData?.products);
      formik.setFieldValue("parent_id", subProductData?.parent_id);
      // formik.setFieldValue("status",subProductData?.status);
      setStatus(subProductData?.status);
    }
  }, []);

  const validationSchema = yup.object({
    parent_id: yup.number().required("This Field is Required"),
    products: yup.string().required("This Field is Required"),
    // status: yup.string().required("This Field is Required"),
  });

  // Formik
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      parent_id: "",
      products: "",
      // status: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      const data = {
        parent_id: Number(values.parent_id),
        products: values.products,
        status: Number(status),
      };

      console.log("values", values);

      try {
        const url = subProductData?.id
          ? `products/update-product/${subProductData?.id}`
          : `products/add-product`;
        const apiRes = await apiCall({
          method: "post",
          url,
          data,
        });
        if (onSubmit)
          onSubmit(apiRes?.message || "Add Sub Product successfully");

        formik.resetForm();
        onClose();
      } catch (error) {
        onError(
          error?.response?.data?.respMsg ||
            error?.response?.data?.responseMessage ||
            error?.response?.data?.message ||
            "Something went wrong"
        );
      }
    },
  });

  return (
    <div style={{ height: "100%", overflow: "auto" }}>
      <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
        {/* Body */}
        <div className={Style.modal_body}>
          <FormArea>
            {/* Product Name */}
            <FeildWraper width="100%">
              <FormLabel required>Main Product</FormLabel>
              <Select
                className="text-sm"
                classNamePrefix="react-select"
                value={
                  mainProducts
                    ?.map((c) => ({
                      value: c.id,
                      label: c.products || "other",
                    }))
                    .find((opt) => opt.value === formik.values.parent_id) ||
                  null
                }
                onChange={(option) => {
                  formik.setFieldValue("parent_id", option?.value || "");
                }}
                options={mainProducts.map((c) => ({
                  value: c.id,
                  label: c.products || "other",
                }))}
                isLoading={loadindProducts}
                isClearable
                placeholder="Search Product..."
                menuPortalTarget={document.body}
                menuPosition="fixed"
                components={{
                  IndicatorSeparator: () => null,
                  LoadingIndicator: () => (
                    <div className="flex items-center pr-2">
                      <Loader2 className="w-4 h-4 text-blue-600 animate-spin" />
                    </div>
                  ),
                }}
                styles={{
                  control: (base, state) => ({
                    ...base,
                    minHeight: "35px",
                    height: "auto",
                    borderRadius: "5px",
                    border: "1px solid #DFDFDF",
                    backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
                    boxShadow: state.isFocused ? "none" : "none",
                    "&:hover": { borderColor: "#DFDFDF" },
                    fontSize: "13px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                    padding: "0 14px",
                    cursor: state.isDisabled ? "not-allowed" : "normal", // cursor change
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    height: "auto",
                    padding: "0 0px 0",
                  }),
                  input: (base) => ({
                    ...base,
                    margin: 0,
                    padding: 0,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                    height: "auto",
                  }),
                  singleValue: (base) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#1E1E1E",
                  }),
                  placeholder: (base) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: "#717680",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 99999,
                  }),
                  menu: (base) => ({
                    ...base,
                    marginTop: "2px",
                    borderRadius: "5px",
                    border: "1px solid #DFDFDF",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }),
                  option: (base, state) => ({
                    ...base,
                    fontSize: "14px",
                    lineHeight: "1.2",
                    fontWeight: 500,
                    color: state.isSelected ? "#FFF" : "#1E1E1E",
                    backgroundColor: state.isSelected
                      ? "#3b82f6"
                      : state.isFocused
                      ? "#F3F4F6"
                      : "#FFF",
                    padding: "8px 14px",
                    cursor: "pointer",
                  }),
                  indicatorContainer: (base) => ({ ...base, padding: 0 }),
                  dropdownIndicator: (base) => ({ ...base, padding: 0 }),
                }}
              />
              {formik.touched.parent_id && formik.errors.parent_id && (
                <FeildError>{formik.errors.parent_id}</FeildError>
              )}
            </FeildWraper>

            {/* Sub Product  */}

            <FeildWraper width="100%">
              <FormLabel required>Sub Product</FormLabel>

              <input
                type="text"
                name="products"
                value={formik.values.products}
                onChange={formik.handleChange}
                placeholder="Product"
              />
              {formik.touched.products && formik.errors.products && (
                <FeildError>{formik.errors.products}</FeildError>
              )}
            </FeildWraper>

            {/* status */}
            <div className="w-full px-3 flex flex-col gap-2">
              <div>
                <p className="!text-sm !font-medium !leading-5  !text-[#1E2E54]">
                  Status
                </p>
              </div>
              <div className="flex gap-5 items-center text-sm">
                <label className="flex gap-1 font-sm font-medium leading-5  text-[#1E2E54]">
                  <input
                    type="radio"
                    name="status"
                    value="upload"
                    checked={status == 1}
                    onChange={() => setStatus(1)}
                  />
                  Active
                </label>

                <label className="flex gap-1 font-sm font-medium leading-5  text-[#1E2E54]">
                  <input
                    type="radio"
                    name="status"
                    value="url"
                    checked={status == 0}
                    onChange={() => setStatus(0)}
                  />
                  In Active
                </label>
              </div>
            </div>
            {/* <FeildWraper width="100%">
              <FormLabel required>Status</FormLabel>
              <select name="status" value={formik.values.status} onChange={formik.handleChange}>
                <option value="" disabled selected>
                  -- Select Product Status --
                </option>
                <option value="1">Active</option>
                <option value="0">InActive</option>
              </select>

              {formik.touched.status && formik.errors.status && (
                <FeildError>{formik.errors.status}</FeildError>
              )}
            </FeildWraper> */}
          </FormArea>
        </div>

        {/* Footer */}
        <div className={Style.modal_foot}>
          <button
            type="button"
            className={`${Style.dcmb__cancel} opacity-0 pointer-events-none cursor-default`}
            onClick={onClose}
          >
            Discard
          </button>
          <button type="submit" className={Style.dcmb__submit}>
            {subProductData?.id ? "Update" : "Apply"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddUpdateSubProduct;
